<template>
  <div class="appointment-time-selector">
    <h2 class="title-with-underline">請選擇就診時間</h2>

    <div class="reminder-grayscale">
      說明：取得可預約日期後，顯示上一頁選擇的可預約日期，它之後可預約的看診時段
    </div>

    <div class="date-selection">
      <div
        v-for="(day, index) in paginatedDates"
        :key="index"
        class="appointment-day"
      >
        <h4 class="date-title">{{ day.date }} ({{ getWeekday(day.date) }})</h4>

        <div class="time-slots-container">
          <button
            v-for="(item, index) in transformSlots(day.timeSlots, day.date)"
            :key="index"
            class="time-slot"
            :class="{
              full: item.isFull,
              unavailable: item.isUnavailable,
              selected: item.value === value && !item.isUnavailable && !item.isFull
            }"
            :disabled="item.isUnavailable || item.isFull"
            @click="handleSelectionChange(item.value)"
          >
            {{ item.label }} {{ item.description }}
          </button>
        </div>
      </div>
    </div>

    <div class="show-more-dates" @click="offset += 5">顯示更多時段</div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AppointmentTimeSelector',
  props: {
    dates: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    },
    selectedDate: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      offset: 5,
    }
  },
  computed: {
    paginatedDates() {
      const startingMoment = this.selectedDate ? moment(this.selectedDate) : moment();

      return this.dates
        .filter(day => moment(day.date).isSameOrAfter(startingMoment, 'day'))
        .slice(0, this.offset);
    },
  },
  methods: {
    handleSelectionChange(selection) {
      this.$emit('input', selection);
    },

    getWeekday(dateString) {
      return ['日', '一', '二', '三', '四', '五', '六'][moment(dateString).day()];
    },

    transformSlots(timeSlots, date) {
      const typeMap = {
        morning: '上午診',
        afternoon: '下午診',
        evening: '夜診'
      };

      return timeSlots.map(slot => {
        // user requirement 1: 依照 text 的文字顯示在頁面
        const timePeriod = slot.text || typeMap[slot.type] || slot.type;
        const description = slot.isFull ? '(滿)' : '';

        return {
          label: timePeriod,
          value: `${date}-${slot.type}`,
          description,
          isFull: slot.isFull,
          isUnavailable: slot.isUnavailable,
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.appointment-day + .appointment-day {
  margin-top: 48px;
}

.date-title {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.date-selection {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 32px 16px;
  margin-bottom: 24px;
}

.time-slots-container {
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  padding: 12px 0;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  @media screen and (min-width: 768px) {
    gap: 16px;
  }
}

.time-slot {
  border: 2px solid #2a9d8f;
  border-radius: 10px;
  padding: 12px 8px;
  background: #fff;
  color: #207868;
  font-size: 14px;
  font-weight: 700;
  flex: 1;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;

  @media screen and (min-width: 768px) {
    padding: 14px 20px;
    font-size: 16px;
  }

  &:not(.full):not(.unavailable):hover {
    background: #2a9d8f;
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(42, 157, 143, 0.3);
  }

  &.selected {
    background: #207868;
    border-color: #207868;
    color: #fff;
  }

  &.full {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &.unavailable {
    color: #bbb;
    border-color: #ddd;
    cursor: not-allowed;
  }
}

.show-more-dates {
  padding: 16px 32px;
  font-weight: 500;
  color: #2a9d8f;
  text-align: center;
  cursor: pointer;
}
</style>
